import { FC } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const MenuCard: FC = () => (
  <ToolCard
    icon={<MenuIcon fontSize="large" />}
    title="Meniu"
    description="Svetainės meniu administravimas"
    action={
      <Button href="menu" startIcon={<MenuIcon />} size="small">
        Administruoti
      </Button>
    }
  />
);

export default MenuCard;
